import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledModal, ModalOverlay, ModalButtonContainer, ModalContent, ModalTitle, ModalDescriptionList, ModalDescriptionItem, ModalAddContentWrapper, } from './Modal.styles';
import { useModal, useModalRender } from './hooks';
export const Modal = () => {
    const { type, title, description, addContent, hideButtons, onConfirm, onCancel, handleCancel, handleConfirm } = useModal();
    const { renderIcon, renderTextWithLineBreaks, renderButtons } = useModalRender({
        type,
        hideButtons,
        onConfirm,
        onCancel,
        handleCancel,
        handleConfirm,
    });
    return (_jsx(ModalOverlay, { children: _jsxs(StyledModal, { children: [renderIcon(), _jsxs(ModalContent, { children: [_jsx(ModalTitle, { "$type": type, children: title }), _jsx(ModalDescriptionList, { children: description?.map((item, index) => (_jsx(ModalDescriptionItem, { children: renderTextWithLineBreaks(item, `modal_desc_num${index}`) }, `modal_desc_num_${index}`))) }), addContent && _jsx(ModalAddContentWrapper, { children: addContent })] }), !hideButtons && _jsx(ModalButtonContainer, { children: renderButtons() })] }) }));
};
//# sourceMappingURL=Modal.js.map